<div class="mfa-page">

  <div class="mfa-container">

    <!-- =========================================
         LOGO
         ========================================= -->
   
    <div class="back-wrapper">
      <button
        type="button"
        class="back-btn"
        (click)="goBack()"
      >
        <i class="fa-solid fa-arrow-left"></i>
        <span>Regresar</span>
      </button>
    </div>


    <div class="logo-wrapper">      
      <img class="blur-up lazyloaded img-logo" [src]="logoUrl"
          (error)="onLogoError($event)" alt="Logo"         
        />
    </div>


    <!-- =========================================
         ENCABEZADO
         ========================================= -->
    <div class="header-section">

      <h1>
        Configurar autenticador
      </h1>

      <p class="subtitle">
        Escanee el código QR con su aplicación autenticadora para
        completar la configuración del doble factor.
      </p>

    </div>


    <!-- =========================================
         DESCRIPCIÓN
         ========================================= -->
    <p class="description">
      Escanee este código con su aplicación autenticadora
      (por ejemplo, Google Authenticator o Microsoft Authenticator)
      desde el dispositivo donde la tiene instalada.
    </p>


    <!-- =========================================
         CÓDIGO QR
         ========================================= -->
    <div class="qr-card">

      <div class="qr-title">

        <i class="fa-solid fa-qrcode"></i>

        <span>
          Código QR
        </span>

      </div>


      <div class="qr-wrapper">

        <!-- Loading -->
        <div
          *ngIf="loadingQr"
          class="qr-loading"
        >

          <i class="fa-solid fa-spinner fa-spin"></i>

          <span>
            Generando código QR...
          </span>

        </div>


        <!-- QR generado por el backend -->
        <img
          *ngIf="qrImage && !loadingQr"
          [src]="qrImage"
          alt="Código QR para configurar doble factor"
          class="qr-image"
        />


        <!-- En caso de no existir QR -->
        <div
          *ngIf="!qrImage && !loadingQr"
          class="qr-error"
        >

          <i class="fa-solid fa-triangle-exclamation"></i>

          <span>
            No fue posible generar el código QR.
          </span>

        </div>

      </div>

    </div>


    <!-- =========================================
         CLAVE MANUAL
         ========================================= -->
    <div class="form-group">

      <label>
        Clave manual
      </label>


      <div class="secret-field">

        <i class="fa-solid fa-key"></i>


        <!-- Clave enviada por backend -->
        <span *ngIf="secretKey">
          {{ secretKey }}
        </span>


        <!-- Mientras carga -->
        <span *ngIf="!secretKey && loadingQr">
          Generando clave...
        </span>


        <button
          type="button"
          class="copy-btn"
          title="Copiar clave"
          [disabled]="!secretKey"
          (click)="copySecret()"
        >

          <i class="fa-regular fa-copy"></i>

        </button>

      </div>

    </div>


    <!-- =========================================
         TEXTO DE AYUDA
         ========================================= -->
    <p class="help-text">

      Si prefiere no escribir la clave manual, puede usar el código QR
      directamente desde su aplicación autenticadora.

      Una vez configurado, ingrese el código actual para confirmar que
      la configuración funciona correctamente.

    </p>


    <!-- =========================================
         FORMULARIO
         ========================================= -->
    <form
      [formGroup]="mfaForm"
      (ngSubmit)="confirmMfa()"
    >


      <!-- Código de verificación -->
      <div class="form-group">

        <label for="verificationCode">
          Código de verificación
        </label>


        <input
          id="verificationCode"
          type="text"
          class="verification-input"
          formControlName="code"
          placeholder="000000"
          maxlength="6"
          inputmode="numeric"
          autocomplete="one-time-code"
        />


        <!-- Error -->
        <small
          class="error"
          *ngIf="
            mfaForm.get('code')?.touched &&
            mfaForm.get('code')?.invalid
          "
        >
          Ingrese un código válido de 6 dígitos.
        </small>

      </div>


      <!-- =========================================
           BOTÓN CONFIRMAR
           ========================================= -->
      <button
        type="submit"
        class="confirm-btn"
        [disabled]="
          mfaForm.invalid ||
          loading ||
          loadingQr ||
          !secretKey
        "
      >

        <!-- Spinner -->
        <i
          *ngIf="loading"
          class="fa-solid fa-spinner fa-spin"
        ></i>


        <!-- Escudo -->
        <i
          *ngIf="!loading"
          class="fa-solid fa-shield-halved"
        ></i>


        <span>
          {{
            loading
              ? 'Validando...'
              : 'Confirmar doble factor'
          }}
        </span>

      </button>

    </form>

  </div>

</div>